namespace TabAurous.Retail {
    export interface POSQuotationRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        POSCustomerId?: number;
        FirstName?: string;
        LastName?: string;
        PosCustomerCode?: string;
        CountryId?: number;
        StateId?: number;
        CityId?: number;
        TermsId?: number;
        BaseItemTypeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: POSQuotationItemsRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        CustomerName?: string;
        ImageName?: string;
        PanNumber?: string;
        Email?: string;
        BirthDate?: string;
        Anniversary?: string;
        Address?: string;
        Mobile?: string;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        MF?: number;
        Username?: string;
    }

    export namespace POSQuotationRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.POSQuotation';
        export const deletePermission = 'Retail:Quotation:Delete';
        export const insertPermission = 'Retail:Quotation:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:Quotation:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            FirstName = "FirstName",
            LastName = "LastName",
            PosCustomerCode = "PosCustomerCode",
            CountryId = "CountryId",
            StateId = "StateId",
            CityId = "CityId",
            TermsId = "TermsId",
            BaseItemTypeId = "BaseItemTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            CustomerName = "CustomerName",
            ImageName = "ImageName",
            PanNumber = "PanNumber",
            Email = "Email",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            Address = "Address",
            Mobile = "Mobile",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            MF = "MF",
            Username = "Username"
        }
    }
}
